// extracted by mini-css-extract-plugin
export default {"cta":"iH-z","disabled":"jH-z"};